import { Directive } from '@angular/core';
import { OpsFocusSelectDirective } from './ops-focus-select.directive';
import { OpsNoiceNumberDirective } from './ops-noice-number.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[nOpsNumber]',
  standalone: true,
  hostDirectives: [OpsFocusSelectDirective, OpsNoiceNumberDirective],
})
export class NOpsNumberDirective {
  constructor() {
    //
  }
}
//
// NumberOnlyDirective,
